module.exports = __webpack_public_path__ + "img/dashboard-gray.c4f945d2.svg";